module.exports = __webpack_public_path__ + "media/images/vp/icon.menu.info.black-2226ccece85a1cc8f03883a9c05ae3e6.svg";